import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, timelineOppositeContentClasses, TimelineSeparator } from '@mui/lab';
import { Grid, Typography } from '@mui/material';
import React from 'react'

export const CustomTimeline = (props) => {
    const {observations} = props
    if(observations) {

        return (
            <Timeline
                sx={{
                [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.1,
                },
                }}
            >
                {observations.map((obs, index) => (
                    <TimelineItem key={obs.id || index}>
                        <TimelineOppositeContent>
                            {obs.log_fecha}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot color='primary'/>
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <Typography variant='body1' sx={{fontWeight: 'bold'}}>
                                {obs.nombre}{': '}  
                            </Typography> 
                            <Typography variant='body1'>
                                {obs.log_observacion}
                            </Typography> 
                        </TimelineContent>
                    </TimelineItem>
                ))}

            </Timeline>
        );
    }   

}
